
const subjects = [
  
    {
      id: 1,
      subject: 'physics',
      name: 'Physics',
      icon: '🪐',
      color: '#3498db',
    },
    {
      id: 2,
      subject: 'chemistry',
      name: 'Chemistry',
      icon: '⚛️', 
      color: '#2ecc71',
    },
    {
      id: 3,
      subject: 'biology',
      name: 'Biology',
      icon: '🧬', 
      color: '#9b59b6',
    }
];

export default subjects;